import createIcon from '../../createIcon';

/**
 * @component @name Hd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuODkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuODkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTExIDE1SDkuNVYxM0g3LjVWMTVINlY5SDcuNVYxMS41SDkuNVY5SDExVjE1Wk0xMyA5SDE3QzE3LjU1IDkgMTggOS40NSAxOCAxMFYxNEMxOCAxNC41NSAxNy41NSAxNSAxNyAxNUgxM1Y5Wk0xNC41IDEzLjVIMTYuNVYxMC41SDE0LjVWMTMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hd = createIcon('Hd', [
  [
    'path',
    {
      d: 'M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM11 15H9.5V13H7.5V15H6V9H7.5V11.5H9.5V9H11V15ZM13 9H17C17.55 9 18 9.45 18 10V14C18 14.55 17.55 15 17 15H13V9ZM14.5 13.5H16.5V10.5H14.5V13.5Z',
      key: '3vdvtn',
    },
  ],
]);

export default Hd;
